var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookCircle = function SvgFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebookCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.506a9.962 9.962 0 0 1-2.933 7.067 9.975 9.975 0 0 1-5.505 2.81v-6.981h2.333l.438-2.896h-2.771V8.63c0-.79.39-1.562 1.629-1.562h1.266V4.611s-1.152-.2-2.238-.2c-2.286 0-3.78 1.39-3.78 3.895v2.2H5.894v2.896h2.543v6.98a9.975 9.975 0 0 1-5.505-2.809A9.961 9.961 0 0 1 0 10.506 9.962 9.962 0 0 1 2.933 3.44 9.962 9.962 0 0 1 10 .506c5.524 0 10 4.477 10 10Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebookCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .506)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFacebookCircle;